import axios from "axios";
import { getApiBaseUrl } from "../configs/apiEnv";

export const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

export default api;
